"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

exports.factHasValue = function (fact) {
  var dataType = fact.dataType,
      _a = fact.changeIndicatorProps,
      changeIndicatorProps = _a === void 0 ? {} : _a,
      _b = fact.riskRatingProps,
      riskRatingProps = _b === void 0 ? {} : _b,
      _c = fact.morningstarRatingProps,
      morningstarRatingProps = _c === void 0 ? {} : _c,
      value = fact.value;

  if (dataType === 'change-indicator') {
    return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(changeIndicatorProps);
  }

  if (dataType === 'risk-rating') {
    return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(riskRatingProps) && riskRatingProps.value > 0;
  }

  if (dataType === 'morningstar-rating') {
    return !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(morningstarRatingProps) && !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(morningstarRatingProps.morningStarRating);
  }

  return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(value);
};